var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stock-take-summary-desktop',{attrs:{"id":_vm.id,"clinic-slug":_vm.warehouseSlug,"list-page":"HQInventoryStockTake"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }